import InfoModal from 'components/InfoModal';
import React from 'react';
import {
  Form,
  Select,
  DropdownItemProps,
  SelectProps,
  FormFieldProps,
} from 'semantic-ui/semantic-ui-imports';
import { InfoText } from 'Types/AppSettings';

interface Props {
  name: string;
  label: string;
  defaultValue?:
    | string
    | number
    | boolean
    | (string | number | boolean)[]
    | undefined;
  value?: string | number | boolean | (string | number | boolean)[] | undefined;
  onChange: (
    name: string,
    val: string | number | boolean | (string | number | boolean)[] | undefined
  ) => void;
  options: DropdownItemProps[];
  selectProps?: SelectProps;
  formFieldProps?: FormFieldProps;
  multiple?: boolean;
  helpText?: InfoText;
  disabled?: boolean;
}

const FilterSelect = ({
  name,
  label,
  defaultValue,
  onChange,
  options,
  selectProps,
  formFieldProps,
  multiple,
  helpText,
  value,
  disabled,
}: Props) => (
  <>
    <Form.Field {...formFieldProps}>
      <label htmlFor={name}> {label} </label>
      <Select
        name={name}
        defaultValue={defaultValue}
        onChange={(
          e: any,
          d: {
            value:
              | string
              | number
              | boolean
              | (string | number | boolean)[]
              | undefined;
          }
        ) => {
          onChange(name, d.value);
        }}
        disabled={disabled}
        options={options}
        multiple={multiple}
        value={value}
        {...selectProps}
      />
      {helpText && <InfoModal infoText={helpText} />}
    </Form.Field>
  </>
);

FilterSelect.defaultProps = {
  selectProps: {},
  formFieldProps: {},
  multiple: false,
};

export default FilterSelect;
